<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <terms-tap :tab="tab"></terms-tap>
        <div class="area_wrap">
          <div class="terms_box">
            <div class="tb_mainTitle">
              <h2>환자의 권리와 의무</h2>
              <span class="rightText">의료법 시행규칙 (제1조의3제1항)</span>
            </div>
            <div class="tb_item">
              <div class="tb_content">
                <div class="tb_title">
                  <h2>1. 환자의 권리</h2>
                </div>
                <div class="tb_text">
                  <div class="tb_detail">
                    <p>가. 진료받을 권리</p>
                    <p>환자는 자신의 건강보호와 증진을 위하여 적절한 보건의료서비스를 받을 권리를
                      갖고, 성별·나이·종교·신분 및 경제적 사정 등을 이유로 건강에 관한 권리를 침해 받지 아니하며,
                      의료인은 정당한 사유 없이 진료를 거부하지 못한다.</p>
                  </div>
                  <div class="tb_detail">
                    <p>나. 알권리 및 자기결정권</p>
                    <p>환자는 담당 의사·간호사 등으로부터 질병 상태, 치료 방법, 의학적 연구대상 여부,
                      장기이식 여부, 부작용 등 예상 결과 및 진료 비용에 관하여 충분한 설명을 듣고
                      자세히 물어볼 수 있으며, 이에 관한 동의 여부를 결정할 권리를 가진다.</p>
                  </div>
                  <div class="tb_detail">
                    <p>다. 비밀을 보호받을 권리</p>
                    <p>환자는 진료와 관련된 신체상·건강상의 비밀과 사생활의 비밀을 침해받지 아니하며,
                      의료인과 의료기관은 환자의 동의를 받거나 범죄 수사 등 법률에서 정한
                      경우 외에는 비밀을 누설·발표하지 못한다.</p>
                  </div>
                  <div class="tb_detail">
                    <p>라. 상담·조정을 신청할 권리</p>
                    <p>환자는 의료서비스 관련 분쟁이 발생한 경우, 한국의료분쟁조정중재원 등에 상담 및 조정 신청을 할 수 있다.</p>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>2. 환자의 의무</h2>
                </div>
                <div class="tb_text">
                  <div class="tb_detail">
                    <p>가. 의료인에 대한 신뢰·존중 의무</p>
                    <p>환자는 자신의 건강 관련 정보를 의료인에게 정확히 알리고, 의료인의 치료계획을 신뢰하고 존중하여야 한다.</p>
                  </div>
                  <div class="tb_detail">
                    <p>나. 부정한 방법으로 진료를 받지 않을 의무</p>
                    <p>환자는 진료 전에 본인의 신분을 밝혀야 하고, 다른 사람의 명의로 진료를
                      받는 등 거짓이나 부정한 방법으로 진료를 받지 아니한다.
                    </p>
                  </div>
                  <div class="tb_detail">
                    <p>[출처] 국가법령정보센터 (<a href="http://www.law.go.kr/" _blank>http://www.law.go.kr/</a>)</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
<!--      <div class="btnWrap visible" @click="agree()">-->
<!--        <button type="button" class="callTerms">확인</button>-->
<!--      </div>-->
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import TermsTap from '@/components/TermsTap'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      tab: {
        third: true
      },
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '환자의 권리와 의무',
        prevUrl: '/login'
      },
      setCount: false
    }
  },
  computed: {
    ...mapGetters([
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
    ]),
    agree () {
      this.$router.push('/login')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
    TermsTap
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
